module.exports = __webpack_public_path__ + "img/Regulation.830262f5.png";